import * as React from "react";
import { usePatient } from "../state/patientContext";
import { GenderValue } from "shared";

import { ReactComponent as AbdominalBloatingFemale } from "../assets/signsAndSymptoms/abdominalBloating_female.svg";
import { ReactComponent as AbdominalBloatingMale } from "../assets/signsAndSymptoms/abdominalBloating_male.svg";
import { ReactComponent as AbdominalPainFemale } from "../assets/signsAndSymptoms/abdominalPain_female.svg";
import { ReactComponent as AbdominalPainMale } from "../assets/signsAndSymptoms/abdominalPain_male.svg";
import { ReactComponent as BloodInTheStoolFemale } from "../assets/signsAndSymptoms/bloodInStool_female.svg";
import { ReactComponent as BloodInTheStoolMale } from "../assets/signsAndSymptoms/bloodInStool_male.svg";
import { ReactComponent as ChestPainFemale } from "../assets/signsAndSymptoms/chestPain_female.svg";
import { ReactComponent as ChestPainMale } from "../assets/signsAndSymptoms/chestPain_male.svg";

import { ReactComponent as ChillsFemale } from "../assets/signsAndSymptoms/chills_female.svg";
import { ReactComponent as ChillsMale } from "../assets/signsAndSymptoms/chills_male.svg";
import { ReactComponent as ConfusionFemale } from "../assets/signsAndSymptoms/confusion_female.svg";
import { ReactComponent as ConfusionMale } from "../assets/signsAndSymptoms/confusion_male.svg";
import { ReactComponent as CoughFemale } from "../assets/signsAndSymptoms/cough_female.svg";
import { ReactComponent as CoughMale } from "../assets/signsAndSymptoms/cough_male.svg";
import { ReactComponent as DryCoughFemale } from "../assets/signsAndSymptoms/dryCough_female.svg";
import { ReactComponent as DryCoughMale } from "../assets/signsAndSymptoms/dryCough_male.svg";
import { ReactComponent as FailureToGainWeightFemale } from "../assets/signsAndSymptoms/failureToGainWeight_female.svg";
import { ReactComponent as FailureToGainWeightMale } from "../assets/signsAndSymptoms/failureToGainWeight_male.svg";
import { ReactComponent as FatigueFemale } from "../assets/signsAndSymptoms/fatigue_female.svg";
import { ReactComponent as FatigueMale } from "../assets/signsAndSymptoms/fatigue_male.svg";
import { ReactComponent as FeverFemale } from "../assets/signsAndSymptoms/fever_female.svg";
import { ReactComponent as FeverMale } from "../assets/signsAndSymptoms/fever_male.svg";
import { ReactComponent as HeadacheFemale } from "../assets/signsAndSymptoms/headache_female.svg";
import { ReactComponent as HeadacheMale } from "../assets/signsAndSymptoms/headache_male.svg";
import { ReactComponent as HeartburnFemale } from "../assets/signsAndSymptoms/heartburn_female.svg";
import { ReactComponent as HeartburnMale } from "../assets/signsAndSymptoms/heartburn_male.svg";
import { ReactComponent as LossOfAppetiteFemale } from "../assets/signsAndSymptoms/lossOfAppetite_female.svg";
import { ReactComponent as LossOfAppetiteMale } from "../assets/signsAndSymptoms/lossOfAppetite_male.svg";

import {
  ReactComponent as LossOfSenseOfSmellFemale,
  ReactComponent as LossOfSenseOfSmellMale,
} from "../assets/signsAndSymptoms/lossOfSenseOfSmell_female.svg";
import { ReactComponent as LossOfTasteFemale } from "../assets/signsAndSymptoms/lossOfTaste_female.svg";
import { ReactComponent as LossOfTasteMale } from "../assets/signsAndSymptoms/lossOfTaste_male.svg";
import { ReactComponent as MemoryLossFemale } from "../assets/signsAndSymptoms/memoryLoss_female.svg";
import { ReactComponent as MemoryLossMale } from "../assets/signsAndSymptoms/memoryLoss_male.svg";

import { ReactComponent as NasalDischargeFemale } from "../assets/signsAndSymptoms/nasalDischarge_female.svg";
import { ReactComponent as NasalDischargeMale } from "../assets/signsAndSymptoms/nasalDischarge_male.svg";
import { ReactComponent as NauseaFemale } from "../assets/signsAndSymptoms/nausea_female.svg";
import { ReactComponent as NauseaMale } from "../assets/signsAndSymptoms/nausea_male.svg";

import { ReactComponent as GroinPainMale } from "../assets/signsAndSymptoms/groinPain_male.svg";
import { ReactComponent as GroinPainFemale } from "../assets/signsAndSymptoms/groinPain_female.svg";
import { ReactComponent as DiarrheaMale } from "../assets/signsAndSymptoms/diarrhea_male.svg";
import { ReactComponent as DiarrheaFemale } from "../assets/signsAndSymptoms/diarrhea_female.svg";

export const useSymptomIcon = (featureId: string): any => {
  const symptomsTable = {
    "FE.8db53656-9f6b-495b-bc1f-d12f609e1566_female": (
      <AbdominalBloatingFemale />
    ),
    "FE.8db53656-9f6b-495b-bc1f-d12f609e1566_male": <AbdominalBloatingMale />,

    "FE.61e21ee4-b9f6-4bf1-acf7-6d3f37fbfc79_female": <AbdominalPainFemale />,
    "FE.61e21ee4-b9f6-4bf1-acf7-6d3f37fbfc79_male": <AbdominalPainMale />,

    "FE.49bb057a-75fb-4250-85dd-7d82eca41ea2_female": <BloodInTheStoolFemale />,
    "FE.49bb057a-75fb-4250-85dd-7d82eca41ea2_male": <BloodInTheStoolMale />,

    "FE.13296653-f2da-465b-aa39-fa8e2ff5e632_female": <ChestPainFemale />,
    "FE.13296653-f2da-465b-aa39-fa8e2ff5e632_male": <ChestPainMale />,

    "FE.89864dbe-ffb7-4389-8c5a-3a9d77a307ef_female": <ChillsFemale />,
    "FE.89864dbe-ffb7-4389-8c5a-3a9d77a307ef_male": <ChillsMale />,

    "FE.2295d0f5-d757-4272-9753-cc531470a4eb_female": <ConfusionFemale />,
    "FE.2295d0f5-d757-4272-9753-cc531470a4eb_male": <ConfusionMale />,

    "FE.63b2a23c-b229-41a0-95de-ad148f67f490_female": <CoughFemale />,
    "FE.63b2a23c-b229-41a0-95de-ad148f67f490_male": <CoughMale />,

    "FE.df602d3b-bb35-42a0-bae9-f82cb6f2d922_female": <DryCoughFemale />,
    "FE.df602d3b-bb35-42a0-bae9-f82cb6f2d922_male": <DryCoughMale />,

    "FE.c3585da7-5d16-4713-b37f-390b08729bb2_female": (
      <FailureToGainWeightFemale />
    ),
    "FE.c3585da7-5d16-4713-b37f-390b08729bb2_male": <FailureToGainWeightMale />,

    "FE.2bc16899-9441-4d34-9c55-3678ebf89d2e_female": <FatigueFemale />,
    "FE.2bc16899-9441-4d34-9c55-3678ebf89d2e_male": <FatigueMale />,

    "FE.78a368de-ffe7-4908-b264-0946a0811307_female": <FeverFemale />,
    "FE.78a368de-ffe7-4908-b264-0946a0811307_male": <FeverMale />,

    "FE.4f76c5f6-2310-47a8-83db-74bbbe8d173d_female": <HeadacheFemale />,
    "FE.4f76c5f6-2310-47a8-83db-74bbbe8d173d_male": <HeadacheMale />,

    "FE.3a3ff196-0a5e-4051-b4da-397801c1e4a1_female": <HeartburnFemale />,
    "FE.3a3ff196-0a5e-4051-b4da-397801c1e4a1_male": <HeartburnMale />,

    "FE.9948f90a-816d-4df9-9c11-8cf3941d7395_female": <LossOfAppetiteFemale />,
    "FE.9948f90a-816d-4df9-9c11-8cf3941d7395_male": <LossOfAppetiteMale />,

    "FE.a059db2f-fad1-4c6a-960a-20a0559f930b_female": (
      <LossOfSenseOfSmellFemale />
    ),
    "FE.a059db2f-fad1-4c6a-960a-20a0559f930b_male": <LossOfSenseOfSmellMale />,

    "FE.96bfb6d7-5ef4-48e1-ac76-b3de14e3cc61_female": <LossOfTasteFemale />,
    "FE.96bfb6d7-5ef4-48e1-ac76-b3de14e3cc61_male": <LossOfTasteMale />,

    "FE.0346a534-4c12-4bde-be9a-45f59770cf09_female": <MemoryLossFemale />,
    "FE.0346a534-4c12-4bde-be9a-45f59770cf09_male": <MemoryLossMale />,

    "FE.da99871d-d4ab-4f02-9ff8-0be37d2449d0_female": <NasalDischargeFemale />,
    "FE.da99871d-d4ab-4f02-9ff8-0be37d2449d0_male": <NasalDischargeMale />,

    "FE.eb7df073-fa9f-42bc-8312-3bcb1b7cdfd7_female": <NauseaFemale />,
    "FE.eb7df073-fa9f-42bc-8312-3bcb1b7cdfd7_male": <NauseaMale />,

    "FE.1c855386-d610-420f-98ee-6f50d8d1a859_female": <GroinPainFemale />,
    "FE.1c855386-d610-420f-98ee-6f50d8d1a859_male": <GroinPainMale />,

    "FE.85b17131-3b77-4e7d-8551-d630a1c66675_female": <DiarrheaFemale />,
    "FE.85b17131-3b77-4e7d-8551-d630a1c66675_male": <DiarrheaMale />,
  };

  const { gender } = usePatient();

  if (!featureId) {
    return null;
  }
  const suggestionId = featureId;
  const genderText = gender === GenderValue.MALE ? "male" : "female";
  const imagePath = suggestionId + "_" + genderText;
  const symptomIcon = symptomsTable[imagePath];

  return symptomIcon;
};
